// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Código de error:",
    "error.search":
      "Busca en nuestra base de conocimiento para obtener más información",
    dismiss: "descartar",
    "installation.title": "",
    "cancelation.button": "Cancelar",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Inicialización fallida",
      description:
        "No se pudo mostrar la página. Comunícate con el servicio de soporte.",
    },
    "EOS-UI-UE": {
      title: "Ocurrió un error.",
      description: "Ocurrió un error. Comunícate con el servicio de soporte.",
    },
    "EOS-IN-BC": {
      title: "Instalación fallida",
      description:
        "No se pudo mostrar el progreso de la instalación. Comunícate con el servicio de soporte.",
    },
    "EOS-IN-UE": {
      title: "Instalación fallida",
      description: "Ocurrió un error. Comunícate con el servicio de soporte.",
    },
    "EOS-IN-FF": {
      title: "Instalación fallida",
      description:
        "No pudimos conectarnos con Epic Online Services. Comunícate con el servicio de soporte.",
    },
    "EOS-IN-FF-*": {
      title: "Instalación fallida",
      description:
        "No pudimos enviar la solicitud a Epic Online Services. Comunícate con el servicio de soporte.",
    },
    fallback: {
      title: "Ocurrió un error.",
      description: "Ocurrió un error. Comunícate con el servicio de soporte.",
    },
  },
};
